import { Icon, Row, Spin } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import * as addOrder from './../../../actions/addOrder';
import { shipperInfor } from './../../../actions/shipperInfor';
import lang from './../../../languages/en';
import { informationDefault } from './../../../reducers/helper/stateDefaultOrder';
import { alertError } from './../../../services/dialog';
import { convertDateToUTC } from './../../../services/dst';
import { titleHead } from './../../../services/helper';
import history from './../../../services/history';
import OrderComponent from './../components';
import Items from './components/items';
import ListModal from './components/modal';
import OrderInformation from './components/order-information';
import ShipTo from './components/ship-to';
import ShipmentOptions from './components/shipment-options';
import ShipmentRemark from'./components/shipment-remark';
import './styles.css';
import TranslationItemName from './../components/translation-item-name';
import handlePermission from '../../app/handlePermission';
import { permissions, FulfillOption as FulfillOptionConst } from '../../../constants';
import { getListProhibitedItems } from './../../../utils/prohibitedItems';
import hanldeException from '../../../services/handleException';
import { getCountry } from '../../../components/render-select';

class AddOrder extends OrderComponent {
    constructor(props) {
        super(props)
        this.state = {
            visibleTranslationItemName: true,
            listItemMapping: [],
            prohibitedItems: []
        }
    }

    componentDidMount() {
        titleHead('Create Order')
        this.settingMappingItemName()
        this.props.shipperInfor()
        this.handleAsyncStart()
        let _this = this;
        getListProhibitedItems().then(res => {
            if (res.data.code === 10001) {
                _this.setState({
                    prohibitedItems: res.data.data.ProhibitedKeyWords
                })
            } else {
                hanldeException(res)
            }
        }).catch(err => {
            hanldeException(err)
        })
    }

    componentDidUpdate(){
        const { information, shipperInformation, classes } = this.props
        if(information.country === undefined && shipperInformation.destinationCountriesCH){
            let country = getCountry(information, shipperInformation.destinationCountriesCH)
            this.props.onChangeInformation({ value: country, column: 'country' })
            if(country){
                classes['country'] = ''
                this.props.onChangeClasses(classes)
            }
        }
    }

    onSaveOrders = (value) => {
        let data = this.convertData(value)
        this.props.addOrder(data)
        this.props.onChange({ value: true, column: 'isLoading' })
        this.props.onChange({ value: false, column: 'confirm_save_order' })
    }

    convertData = (value) => {
        let information = this.props.information
        let itemNew = this.convertItems(value)

        let data = {
            ChannelOrderID: information['channel_order'],
            ChannelOrderCH: information['channel'],
            CollectAmount: information['CollectAmount'],
            OrderDate: convertDateToUTC(information['order_date_utc']).format('YYYY-MM-DD HH:mm'),
            DeliveryTime: information['preferred_time'].toString(),
            PaymentTerm: information['terms'],
            Currency: information['currency'],
            ConsigneeName: information['name'],
            ConsigneeKanaNameCH: information['yomigana'],
            ConsigneePhone: information['phone'],
            ConsigneeEmail: information['email'],
            ConsigneeCountry: information['country'],
            ConsigneeAddress1: information['address1'],
            ConsigneeAddress2: information['address2'],
            ConsigneeAddress3: information['address3'],
            ConsigneeAddress4: information['address4'],
            ConsigneePostalCode: information['postal_code'] ? information['postal_code'].toString() : '',
            AddressType: information['address_type'],
            FulfillmentOption: information['FulfillmentOption'],
            Items: itemNew,
            ChangeItemOrder: this.props.order.mappingOrderSameSku,
            Remark: information['Remark'],
            HandlingCharge: information['HandlingCharge'],
            NoOfPackages: information['NoOfPackages'] && information['FulfillmentOption'] === FulfillOptionConst.IN_HOUSE.CODE ? Number(information['NoOfPackages']) : 1
        }
        return data;
    }

    confirmSaveOrder = () => {
        const { itemOrder } = this.props

        if (itemOrder.length < 1) {
            alertError(lang.item_required_least_one)
            return;
        }
        if (!this.validateRequired('save')) {
            alertError(lang.field_some_required)
            return;
        }
        if (!this.validateError()) {
            this.props.onChange({ value: true, column: 'confirm_save_order' })
            return;
        }

        this.confirmItemNameMapping('addOrder');
    }

    resetState = () => {
        const { classes } = this.props

        classes.email = ''
        classes.yomigana = 'error'

        this.props.onChange({ value: [], column: 'error' })
        this.props.stateInformationClassesDefault(classes)
        this.props.stateInformationDefault(informationDefault())
    }

    async handleAsyncStart() {
        await this.resetState()
        await this.validateRequired()
    }

    cancelTranslationItemName = (value) => {
        this.setState({
            visibleTranslationItemName: value
        })
    }

    render() {
        return (
            <Spin spinning={this.props.order.isLoading} tip='Loading'>
                {handlePermission(permissions.OrderCreateNewOrder) ?
                    <div id="add-order">
                        <div className="edit-title">Create Order</div>
                        <Icon className='close-order-animation' onClick={() => history.push('/orders')} type="close" theme="outlined" />
                        <Row className='content-add-order'>
                            <OrderInformation
                                onBlur={this.onBlur}
                                onFocus={this.onFocus}
                                validateEmpty={this.validateEmpty}
                            />
                            <Row gutter={8} className='ship-to-shipment-option'>
                                <ShipTo
                                    onBlur={this.onBlur}
                                    onFocus={this.onFocus}
                                    validateEmpty={this.validateEmpty}
                                />
                                <ShipmentOptions
                                    onBlur={this.onBlur}
                                />
                            </Row>
                            <Row className='shipment-remark'>
                                <ShipmentRemark
                                    onBlur={this.onBlur}
                                    onFocus={this.onFocus}
                                />
                            </Row>
                            <Row>
                                <Items
                                    maxSizeSku={this.state.maxSizeSku}
                                    validateEmpty={this.validateEmpty}
                                    prohibitedItems={this.state.prohibitedItems}
                                />
                            </Row>
                            <ListModal
                                confirmSaveOrder={this.confirmSaveOrder}
                                onSaveOrders={this.onSaveOrders}
                                prohibitedItems={this.state.prohibitedItems}
                            />
                        </Row>
                        <TranslationItemName
                            listItemMapping={this.state.listItemMapping}
                            ref={e => this.translationItemNameRef = e}
                            onChange={this.props.onChange}
                            order={this.props.order}
                            confirmMapping={this.confirmMapping}
                            confirmTypeMapping={this.confirmTypeMapping}
                            pageType='addOrder'
                        />
                    </div>
                    : ''
                }
            </Spin>
        )
    }
}

const mapStateToProps = state => {
    return {
        isDisable: state.addOrder.isDisable,
        confirm_save_order: state.addOrder.confirm_save_order,
        itemOrder: state.addOrder.items,
        order: state.addOrder,
        information: state.addOrder.information,
        shipperInformation: state.addOrder.shipperInformation,
        classes: state.addOrder.classes
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addOrder: payload => {
            dispatch(addOrder.addOrder(payload))
        },
        onChange: payload => {
            dispatch(addOrder.onChange(payload))
        },
        onChangeItem: payload => {
            dispatch(addOrder.onChangeItem(payload))
        },
        onChangeClasses: payload => {
            dispatch(addOrder.onChangeClasses(payload))
        },
        stateInformationDefault: payload => {
            dispatch(addOrder.stateInformationDefault(payload))
        },
        stateInformationClassesDefault: payload => {
            dispatch(addOrder.stateInformationClassesDefault(payload))
        },
        onChangeInformation: payload => {
            dispatch(addOrder.onChangeInformation(payload))
        },
        shipperInfor: payload => {
            dispatch(shipperInfor(payload))
        },
        convertName: payload => {
            dispatch(addOrder.convertName(payload))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddOrder)



// WEBPACK FOOTER //
// ./src/containers/orders/add/index.js